import './css/Aulas.css'; 
import Espera from '../Espera';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ClaseActividadesForm from './ClaseActividadesForm';
import CONFIG from '../../config';
import { useNavigate } from 'react-router-dom';

const URL  = `${CONFIG.API_URL}/operarClases.php`;

function ClaseActividades({setCantActividades, enviarSolicitud, id_curso, id_clase, setEditaActividad, editaActividad}) {
    const [actividadesCurso, setActividadesCurso] = useState([]);
   // const [actividadesClase, setActividadesClase] = useState([]);
    const [trabajosCurso, setTrabajosCurso] = useState([]);
    const [cuestionarioCurso, setCuestionarioCurso] = useState([]);
    const [trabajosClase, setTrabajosClase] = useState([]);
    const [cuestionarioClase, setCuestionarioClase] = useState([]);
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);    

    const data= {
        'id_curso' : id_curso,
        'modo': 'buscarActividadesEspacioCurso'
    }
    
    useEffect(() => {
        buscaActividadesCurso(data);
    }, [id_clase, editaActividad]);

    useEffect(() => {
        setCantActividades(trabajosClase.length + cuestionarioClase.length );
    }, [trabajosClase,cuestionarioClase]);
    
    const buscaActividadesCurso = (d) =>{
        setVisible(true);
        axios.post(URL, d)
        .then(res =>{
            //console.log('dd:'+JSON.stringify(res.data));
            if(!res.data.error){   
               // setActividadesCurso(res.data.trabajos)
                setTrabajosCurso(res.data.trabajos)
                console.log('trabajos:'+res.data.trabajos)
                
                //filtrar las trabajos de la clase actual
                setTrabajosClase(res.data.trabajos.filter((trabajo)=>{
                    if( trabajo.id_clase==id_clase ){
                        return true;
                    }
                    return false;
                }))
               
                setCuestionarioCurso(res.data.cuestionarios)
                //console.log('cuestionarios1:'+JSON.stringify(res.data.cuestionarios))

                //filtrar las cuestionarios de la clase actual
                setCuestionarioClase(res.data.cuestionarios.filter((cuestionario)=>{
                    if( cuestionario.id_clase==id_clase ){
                        return true;
                    }
                    return false;
                }))
                console.log('cuest.:'+ res.data.cuestionarios.filter((cuestionario)=>{
                    if( cuestionario.id_clase==id_clase ){
                        return true;
                    }
                    return false;
                }));
                setCantActividades(trabajosClase.length + cuestionarioClase.length);
            }else{
                setActividadesCurso([]);
            }
            setVisible(false);           
        })
        .catch(err=>{
            console.log(err);
        })   
    }

    const quitarActividad = (id_trabajo_clase) => {
        enviarSolicitud('DELETE', {'id': id_trabajo_clase, 'tabla': 'trabajo_clase'});
        setEditaActividad(false);
    }

    return (    
        <div>
        {editaActividad && 
            <ClaseActividadesForm 
            setEditaActividad={setEditaActividad} 
            id_clase={id_clase} 
            trabajosCurso={trabajosCurso} 
            cuestionarioCurso={cuestionarioCurso}
            enviarSolicitud={enviarSolicitud} />
        }
        {!visible ? 
    (
        <> {cuestionarioClase.length !== 0 ? 
                 cuestionarioClase.map((ccl) => (<>
                    <div key={ccl.id} className="cuestionario-timeline">
                        <div class="cuestionario">
                            <i class="fas fa-list icono"></i>
                            <div class="detalle">
                                <div className='titulo-detalle'>
                                    <h5 onClick={()=>navigate(`/cuestionario/${ccl.id}`)}>{ccl.titulo.substr(0, 35)}</h5>
                                    {editaActividad && 
                                        <a onClick={() => quitarActividad(ccl.id_trabajo_clase)}>
                                            <i class="fa-regular fa-trash-can"></i>
                                        </a>
                                    }
                                </div> 
                                <p>{ccl.descripcion}</p>
                            </div>
                        </div>
                    </div>
                    
                </>))
            : <div></div>}
            {trabajosClase.length !== 0 ? trabajosClase.map((acl) => (
                <div key={acl.id} className="actividad-timeline">
                    <div className='actividad'>
                        <i className="fa-solid fa-briefcase icono"></i>
                        <div class="detalle">
                                <div className='titulo-detalle'>
                                    <h5>{acl.titulo.substr(0, 35)}</h5>
                                    {editaActividad && 
                                        <a onClick={() => quitarActividad(acl.id_trabajo_clase)}>
                                            <i class="fa-regular fa-trash-can"></i>
                                        </a>
                                    }
                                </div> 
                                <p>{acl.desarrollo}</p>
                            </div>
                    </div>  
                    
                </div>
            )) : <div></div>}

           
        </>
    ) 
    : <div className='container m-3'><Espera visible={visible} /></div>
}

    </div>
    );
}

export default ClaseActividades;
